

















import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
    import Logs from "@/consoleapi/api/restcomm/logs";
import {Pages} from "@/class/pages";

    @Component
    export default class Notifications extends Vue {
      private notifications = {};

      @Prop()
      private currentPage!: number;

      private logs = new Logs();

      getNotifications(page = 0) {
        this.logs.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        this.logs.getNotifications(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)),page)
            .then(response => {
              console.log(response.data);
              this.notifications = response.data.notifications;
              const pages: Pages = {
                current: response.data.page,
                max: response.data.num_pages,
                size: response.data.page_size,
                total: response.data.total,
                url: this.logs.getRequestUri(),
              }
              this.passMaxPages(pages);
            }).catch(error => {
          console.log(error.response);
        });
      }

      mounted() {
        this.getNotifications();
      }

      @Watch('currentPage')
      currentPageChanged(current: number, old: number) {
        if (current !== old) {
          this.getNotifications(current);
        }
      }

      @Emit('pages')
      passMaxPages(pages: Pages){
        console.log(pages);
        //this.getCalls(pages);
      }
    }
